module.exports = __webpack_public_path__ + "static/img/avatar_5.904093b.png";


//////////////////
// WEBPACK FOOTER
// ./static/avatars/avatar_5.png
// module id = 1596
// module chunks = 61